import React, { useEffect, useState } from "react"
import UserTokenRow from './components/UserTokenRow'
import HelloSsoRow from './components/HelloSsoRow'
import {Button} from '@bluedot-innovation/bluedot-ui'
import { useAccountFeatures, ACCOUNT_FEATURES } from '../../hooks/account-features'
import lodashGet from 'lodash.get'
import {Link} from "@reach/router";
import * as styled from "./styled"

export default({id}) => {
    // const [isSecureHelloOrders, setIsSecureHelloOrders] = useState(false);
    // const [error, setError] = useState();
    const [helloConfigurationUpdated, setHelloConfigurationUpdated] = useState(false);
    const [alertMessage, setAlertMessage] = useState();

    const {
        features,
        updateErrors,
        retrievalError,
        retrieveFeatures,
        patchFeatures
    } = useAccountFeatures({ accountId: id })

    useEffect(() => {
        retrieveFeatures()
    }, [])

    // useEffect(() => {
    //     const secureHelloOrdersFlag = async (accountId) => {
    //         const result = await getSecureHelloOrdersFlag(accountId)
    //         if (result) {
    //             setIsSecureHelloOrders(!!result.secureHelloOrders)
    //         }
    //     }
    //     secureHelloOrdersFlag(id)
    // }, [id])
    //
    // const toggleSecureHelloOrdersFlag = async (accountId, isSecureHelloOrders) => {
    //     try {
    //         await setSecureHelloOrdersFlag(accountId, isSecureHelloOrders)
    //         setIsSecureHelloOrders(isSecureHelloOrders)
    //     } catch (err) {
    //         console.log(err)
    //         setError('Failed to toggle Secure Hello Orders flag.')
    //     }
    // }

    const getFeatErrorMsg = (path) => lodashGet(updateErrors, `${path}.msg`)

    const updateUserTokenlength = async (length) => {
        const result = await patchFeatures(`${ACCOUNT_FEATURES.Screens}.configuration`, { userTokenLength: parseInt(length, 10) })
        if (result.success) {
            setAlertMessage('Successfully update userToken length')
            setHelloConfigurationUpdated(true)
        }
    }

    const updateHelloSso = async (helloSso) => {
        const result = await patchFeatures(`${ACCOUNT_FEATURES.HelloSso}`, helloSso)
        if (result.success) {
            setAlertMessage('Successfully update Hello SSO')
            setHelloConfigurationUpdated(true)
        }
    }

    const deleteHelloSso = async () => {
        const result = await patchFeatures(`${ACCOUNT_FEATURES.HelloSso}`, null, 'remove')
        if (result.success) {
            setAlertMessage('Successfully delete Hello SSO')
            setHelloConfigurationUpdated(true)
        }
    }

    useEffect(() => {
        if (helloConfigurationUpdated) {
            if (alertMessage) {
                alert(alertMessage)
            }
            setHelloConfigurationUpdated(false)
            setAlertMessage("")
        }
    }, [helloConfigurationUpdated, alertMessage])

    return (

        <div>
            <label className="box-label">Configure Hello Orders</label>
            {/*<FeatureToggleRow*/}
            {/*    name="Secure Hello Orders"*/}
            {/*    description="Secure Hello orders by forcing the presentation of userToken in orders' events"*/}
            {/*    errorMsg={error}*/}
            {/*    value={isSecureHelloOrders}*/}
            {/*    setValue={(value) => toggleSecureHelloOrdersFlag(id, value)}*/}
            {/*/>*/}
            <UserTokenRow
                name="Add the length of the userToken"
                description="Default: 7 characters, Min: 7 and Max: 20. In Store Screens must be enabled to use this feature"
                errorMsg={getFeatErrorMsg(`${ACCOUNT_FEATURES.Screens}.configuration`)}
                feat={lodashGet(features, `${ACCOUNT_FEATURES.Screens}`)}
                updateUserTokenlength={(value) => updateUserTokenlength(value)}
            />

            <HelloSsoRow
                name="Hello SSO"
                description="Enable Hello Screens login via the customer’s external identity provider"
                feat={lodashGet(features, `${ACCOUNT_FEATURES.HelloSso}`)}
                updateHelloSso={(helloSso) => updateHelloSso(helloSso)}
                deleteHelloSso={() => deleteHelloSso()}
                errorMsg={getFeatErrorMsg(`${ACCOUNT_FEATURES.HelloSso}`)}
            />


                <styled.ConfigureTtlLinkWrapper>
                    <styled.TtlLinkText>Configure Hello Order Time To Live For Projects</styled.TtlLinkText>
                    <Link to={`/customer/${id}/helloTtl`}>
                        <styled.ButtonWrapper>
                            <Button semiRound size="small">Configure</Button>
                        </styled.ButtonWrapper>
                    </Link>
                </styled.ConfigureTtlLinkWrapper>


        </div>
    )
}
